import axios from "axios";

const state = {
}

const mutations = {
}

const actions = {

  // get otp
  async sentOtpRequest({ commit, dispatch, state }, data) {
    let formData = new FormData();
    formData = data;
    const res = await axios
      .post(
        `${process.env.VUE_APP_PRODUCTION_API_CPS}/api/mymatch_otp/getotp.php`,
        formData,
      )
      .then(response => response)
      .then(({ data }) => data)
      .catch(function (error) {
        console.error("Error:", error);
      });
    return res;
  },

  //check otp
  async sentOtpVerify({ commit, dispatch, state }, data) {
    let formData = new FormData();
    formData = data;
    const res = await axios
      .post(
        `${process.env.VUE_APP_PRODUCTION_API_CPS}/api/mymatch_otp/checkotp.php`,
        formData,
      )
      .then(response => response)
      .then(({ data }) => data)
      .catch(function (error) {
        console.error("Error:", error);
      });
    return res;
  },

  // get register after enter mobile
  async getregister({ commit, dispatch, state }, data) {
    let formData = new FormData();
    formData = data;
    const res = await axios
      .post(
        `${process.env.VUE_APP_PRODUCTION_API_CPS}/api/mymatch/getregister.php`,
        formData,
      )
      .then(response => response)
      .then(({ data }) => data)
      .catch(function (error) {
        console.error("Error:", error);
      });
    return res;
  },

  // set resgister for new user
  async setregister({ commit, dispatch, state }, data) {
    let formData = new FormData();
    formData = data;
    const res = await axios
      .post(
        `${process.env.VUE_APP_PRODUCTION_API_CPS}/api/mymatch/setregister.php`,
        formData,
      )
      .then(response => response)
      .then(({ data }) => data)
      .catch(function (error) {
        console.error("Error:", error);
      });
    return res;
  },

  // save answer 
  async sentAnswer({ commit, dispatch, state }, data) {
    let formData = new FormData();
    formData.append('quiz_type', data.quiz_type);
    data.answer.forEach((v, i) =>
      formData.append('answer[]', v)
    );
    formData.append('sku', data.sku);
    formData.append('mobile', data.mobile);
    formData.append('code', data.code);
    const res = await axios
      .post(
        `${process.env.VUE_APP_PRODUCTION_API}/api/create_answer.php`,
        formData,
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded"
          }
        }
      )
      .then(response => response)
      .then(({ data }) => data)
      .catch(function (error) {
        console.error("Error:", error);
      });
    return res;
  },

  // save log search
  async searchLog({ commit, dispatch, state }, data) {
    let formData = new FormData();
    formData.append('brand', data.brand);
    formData.append('series', data.series);
    formData.append('shade', data.shade);
    const res = await axios
      .post(
        `${process.env.VUE_APP_PRODUCTION_API}/api/search_log.php`,
        formData,
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded"
          }
        }
      )
      .then(response => response)
      .then(({ data }) => data)
      .catch(function (error) {
        console.error("Error:", error);
      });
    return res;
  },


  // save log answer
  async answerLog({ commit, dispatch, state }, data) {
    let formData = new FormData();
    formData.append('session', data.session);
    formData.append('ques_type', data.ques_type);
    formData.append('result', data.result);
    const res = await axios
      .post(
        `${process.env.VUE_APP_PRODUCTION_API}/api/answer_log.php`,
        formData,
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded"
          }
        }
      )
      .then(response => response)
      .then(({ data }) => data)
      .catch(function (error) {
        console.error("Error:", error);
      });
    return res;
  },


  // คำนวนความกว้างxสูงของรูป
  async resize({ commit, dispatch, state }, data) {
    // ขนาดรูปภาพ
    const fullhdWidth = 740;
    const fullhdHeight = 1440;
    let fullhdRatio = fullhdWidth / fullhdHeight; // 0.51
    // ขนาดหน้าจอ
    let containerWidth = window.innerWidth;
    let containerHeight = window.innerHeight;;
    let containerRatio = containerWidth / containerHeight;
    let realWidth = null;
    let realHeight = null;
    containerWidth = containerWidth;
    fullhdRatio = parseFloat(fullhdRatio).toFixed(2);


    // if (containerRatio > fullhdRatio) {
    // realWidth = containerWidth;
    realHeight = containerWidth / fullhdRatio;
    // }
    // else {
    // realWidth = containerHeight * fullhdRatio;
    // realHeight = containerHeight;
    // }

    let response = `${Math.floor(realHeight)}px`;

    return response;

  }
}

export default {
  state,
  mutations,
  actions,
}
